import * as React from "react";

import HardwareImg from "../../assets/print_wheel.jpg";
import SoftwareImg from "../../assets/robocupjo2026/field_and_ai_screen.png";

const PROJECTS = [
  {
    title: "ハードウェア班",
    role: "機体設計・製作",
    image: HardwareImg,
    alt: "3DプリンターでSSLロボットのオムニホイールを製作する様子",
    summary:
      "TRAPSのロボットは、3Dプリント部品を多く使っています。金属加工設備が限られる環境で11台を製作・運用するために選んだ構成です。",
    details: [
      {
        title: "金属加工に頼らない機体",
        body:
          "他チームの機体と比べても金属部品が少なく、3Dプリント部品の比率が高いことが特徴です。筐体は可動部まで含めて一体成形。オムニホイール、キック機構、ローラー式のドリブル機構を備えた機体をチーム内で設計・製作しています。",
      },
      {
        title: "試合の負荷と日々の整備",
        body:
          "高速移動を続け、ときにはロボット同士が衝突する試合では、樹脂部品にも大きな負荷がかかります。強度を確保する一方で、11台分の組み立てや部品交換に時間を取られない構造にしています。",
      },
    ],
  },
  {
    title: "ソフトウェア班",
    role: "戦術・経路計画・機体制御",
    image: SoftwareImg,
    alt: "SSLフィールドとロボット制御ソフトウェアの開発画面",
    summary:
      "制御サーバーが試合全体を判断し、各ロボットがその指令を実際の動きに変えます。TRAPSでは、C++とPythonを中心にサーバーと機体の両方を開発しています。",
    details: [
      {
        title: "制御サーバー",
        body:
          "座標データと審判信号を受信し、カルマンフィルタで状態を補正します。その情報をもとに動作目的、役割、個々の戦術を決め、経路を計画して最大11台へ無線で指令を送ります。",
      },
      {
        title: "機体制御",
        body:
          "各ロボットにはJetsonとFPGAを搭載しています。IMUから得た姿勢・運動情報を使い、サーバーから届いた指令どおりに動くための車体制御を行います。",
      },
    ],
  },
];

export default function Projects() {
  return (
    <section className="trps-section trps-dark" id="Projects">
      <div className="trps-wrap">
        <h2 className="trps-h">開発体制</h2>
        <p className="trps-sub">
          機体の設計・製作から、試合を動かすソフトウェアまでをチーム内で開発しています。
        </p>

        <div className="trps-projects">
          {PROJECTS.map((p) => (
            <article className="trps-proj" key={p.title}>
              <div className="trps-proj__media">
                <img src={p.image} alt={p.alt} />
              </div>
              <div className="trps-proj__body">
                <h3 className="trps-proj__title">{p.title}</h3>
                <p className="trps-proj__role">{p.role}</p>
                <p className="trps-proj__summary">{p.summary}</p>

                <div className="trps-proj__details">
                  {p.details.map((detail) => (
                    <div className="trps-proj__detail" key={detail.title}>
                      <h4>{detail.title}</h4>
                      <p>{detail.body}</p>
                    </div>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
